import { Injectable } from '@angular/core';

@Injectable()
export class NgxExcelComponentService {

  /**
   * åè®¸èªå¨æäº¤çå­æ®µ
   */
  public autoCommitKeys: string[] = [];

}
